import { Grid, Typography } from '@mui/material'

interface ValidationMessageProps {
    /** Image source URL for the validation icon */
    source: string;
    /** When true, applies the disabled styling to the title text */
    disabled?: boolean;
    /** Text label displayed next to the icon */
    title: string;
}

const ValidationMessage = ({
    source,
    disabled =  false,
    title
}: ValidationMessageProps) => {
    return (
        <>
            <Grid container alignItems='center' className='ss-change-flex-container'>
                <img src={source} alt="Icons" className='ss-change-password-validation-icon' />
                <Typography className={disabled ? `ss-change-password-validation-title disabled`: `ss-change-password-validation-title`}>{title}</Typography>
            </Grid>
        </>
    )
}

export default ValidationMessage
